export const BookingPathKeys = {
    basePath: 'basePath',
    startSignInPath: 'startSignInPath',
    // Somehow .07% of our users are still routed to createaccount
    createAccountPath: 'createAccountPath',
    registerPath: 'registerPath',
    selectPatientPath: 'selectPatientPath',
    appointmentInfoPath: 'appointmentInfoPath',
    reviewAndBookPath: 'reviewAndBookPath',
    phoneVerificationPath: 'phoneVerificationPath',
    phoneEntryPath: 'phoneEntryPath',
    appointmentDetailsPath: 'appointmentDetailsPath',
    bookingCompletePath: 'bookingCompletePath',
    legacySyncPath: 'legacySyncPath',
    medicalTeamPath: 'medicalTeamPath',
    patientInfoPath: 'patientInfoPath',
    signUpPath: 'signUpPath',
    signInPath: 'signInPath',
};

export const basePath = '/booking';

export const paths = {
    [BookingPathKeys.appointmentDetailsPath]: `${basePath}/review`,
    [BookingPathKeys.appointmentInfoPath]: `${basePath}/start`,
    [BookingPathKeys.basePath]: basePath,
    [BookingPathKeys.bookingCompletePath]: `${basePath}/complete`,
    // Somehow .07% of our users are still routed to createaccount
    [BookingPathKeys.createAccountPath]: `${basePath}/createaccount`,
    [BookingPathKeys.registerPath]: `${basePath}/register`,
    [BookingPathKeys.reviewAndBookPath]: `${basePath}/reviewandbook`,
    [BookingPathKeys.phoneEntryPath]: `${basePath}/phoneentry`,
    [BookingPathKeys.phoneVerificationPath]: `${basePath}/verify`,
    [BookingPathKeys.selectPatientPath]: `${basePath}/patient`,
    [BookingPathKeys.startSignInPath]: `${basePath}/startsignin`,
    [BookingPathKeys.patientInfoPath]: `${basePath}/patientinfo`,
    [BookingPathKeys.signUpPath]: `${basePath}/signup`,
    [BookingPathKeys.signInPath]: `/signin`,

    // legacy paths left here for ab experiments
    [BookingPathKeys.legacySyncPath]: `${basePath}/sync`,

    // paths outside of booking flow
    [BookingPathKeys.medicalTeamPath]: '/patient/medicalteam',
};

export const BASE_BOOKING_GA_CATEGORY = 'Booking';

export const BOOKING_GA_CATEGORIES = {
    [BookingPathKeys.basePath]: BASE_BOOKING_GA_CATEGORY,
    [BookingPathKeys.startSignInPath]: 'Booking - Sign In',
    // Somehow .07% of our users are still routed to createaccount
    [BookingPathKeys.createAccountPath]: 'Booking - Express Checkout',
    [BookingPathKeys.registerPath]: 'Booking - Express Checkout',
    [BookingPathKeys.selectPatientPath]: 'Booking - Select Patient',
    [BookingPathKeys.appointmentInfoPath]: 'Booking - Review',
    [BookingPathKeys.reviewAndBookPath]: 'Booking - Review And Book',
    [BookingPathKeys.phoneVerificationPath]: 'Booking - Phone Ver',
    [BookingPathKeys.phoneEntryPath]: BASE_BOOKING_GA_CATEGORY,
    [BookingPathKeys.appointmentDetailsPath]: 'Booking - Details',
    [BookingPathKeys.bookingCompletePath]: 'Booking - Booking Complete',
    [BookingPathKeys.patientInfoPath]: 'Booking - Patient Info',
    [BookingPathKeys.signUpPath]: 'Booking - Sign Up',
    [BookingPathKeys.signInPath]: 'Sign In',
    [BookingPathKeys.legacySyncPath]: '',
    [BookingPathKeys.medicalTeamPath]: '',
};
